(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linde-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('linde-tabs')) {
    class LindeTabs extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector(':scope > .linde-tabs__bar-wrapper [role="tablist"]');
        this.panelsContainer = this.querySelector(':scope > .linde-tabs__panels');
        if (!this.bar || !this.panelsContainer) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.tabs.includes(tab)) this.select(tab.dataset.tabId);
        };
        this.onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index === -1) return;
          const last = this.tabs.length - 1;
          const next = {
            ArrowRight: index === last ? 0 : index + 1,
            ArrowLeft: index === 0 ? last : index - 1,
            Home: 0,
            End: last,
          }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next].dataset.tabId, true);
        };
        // Theme editor: selecting a tab (or anything inside it) shows that tab.
        this.onBlockSelect = (event) => {
          const panel = event.target.closest?.('[role="tabpanel"]');
          if (panel && this.panels.includes(panel)) this.select(panel.dataset.tabId);
        };
        this.onHashChange = () => this.selectFromHash();

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('hashchange', this.onHashChange);

        // The theme editor re-renders a Tab block on its own when its settings change,
        // so the buttons are rebuilt from the panels whenever they change.
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this.panelsContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-tab-title', 'data-anchor'],
        });

        this.refresh();
        if (!this.selectFromHash() && this.panels.length) this.select(this.panels[0].dataset.tabId);
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('hashchange', this.onHashChange);
      }

      refresh() {
        this.panels = [...this.panelsContainer.children].filter((el) => el.matches('[role="tabpanel"]'));

        this.tabs = this.panels.map((panel) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'linde-tabs__tab';
          tab.id = `LindeTab-${panel.dataset.tabId}`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          tab.dataset.tabId = panel.dataset.tabId;
          if (panel.dataset.anchor) tab.dataset.anchor = panel.dataset.anchor;
          tab.textContent = panel.dataset.tabTitle || 'Tab';
          return tab;
        });
        this.bar.replaceChildren(...this.tabs);
        this.bar.hidden = !this.tabs.length;

        const keep = this.panels.some((panel) => panel.dataset.tabId === this.activeId);
        if (this.panels.length) this.select(keep ? this.activeId : this.panels[0].dataset.tabId);
      }

      selectFromHash() {
        const hash = decodeURIComponent(window.location.hash.slice(1));
        const tab = hash && this.tabs.find((t) => t.dataset.anchor === hash);
        if (tab) this.select(tab.dataset.tabId);
        return Boolean(tab);
      }

      select(id, focus = false) {
        this.activeId = id;
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tabId === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active) {
            if (focus) tab.focus({ preventScroll: true });
            // Keep the selected tab visible when the bar scrolls horizontally, without moving the page.
            if (this.bar.scrollWidth > this.bar.clientWidth) {
              this.bar.scrollTo({ left: tab.offsetLeft - (this.bar.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
            }
          }
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabId !== id;
        });
      }
    }

    customElements.define('linde-tabs', LindeTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
